import * as React from 'react';
import styled from 'styled-components';
import { InputError } from './InputError';

export interface ITextarea {
  nybygg?: boolean;
  name?: string;
  label?: string;
  labelAfter?: string;
  placeholder?: string;
  value?: string | number;
  error?: boolean;
  errorMessage?: string;
  forwardRef?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
}

export const Textarea: React.FC<ITextarea> = React.memo(
  React.forwardRef((props, ref) => {
    return (
      <StyledInputWrapper>
        {props.label ? (
          <label>
            {props.label}{' '}
            {props.labelAfter ? <span>{props.labelAfter}</span> : null}
          </label>
        ) : null}
        {props.error && props.errorMessage ? (
          <InputError>{props.errorMessage}</InputError>
        ) : null}
        <StyledTextarea
          ref={ref}
          className={props.nybygg ? 'nybygg' : ''}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          error={props.error}
          row={15}
        />
      </StyledInputWrapper>
    );
  })
);

const StyledInputWrapper = styled.div`
  width: 100%;

  label {
    display: block;
    color: ${(props) => props.theme.input.label};
    margin-bottom: 10px;

    span {
      color: ${(props) => props.theme.input.labelAfter};
    }
  }
`;

const StyledTextarea: any = styled.textarea`
  display: block;
  padding: 15px;
  width: 100%;
  background: ${(props: any) => props.theme.input.background};
  font-size: 16px !important;
  font-weight: 400;
  font-family: inherit;
  color: white;
  border: ${(props: any) =>
    props.error
      ? `solid 2px ${props.theme.input.error}`
      : 'solid 2px transparent'};
  outline: none;
  border-radius: 0;
  resize: none;
  appearance: none;

  &:focus {
    outline: none;
    background: ${(props: any) => props.theme.input.background} !important;
  }

  &::placeholder {
    color: ${(props: any) => props.theme.input.placeholder};
  }

  &.nybygg {
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);

    &::placeholder {
      color: rgb(0, 0, 0);
    }
  }
`;
